import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiGrid, FiFolderPlus, FiUsers, FiMessageSquare, FiCalendar, FiAward, FiSettings, FiLogOut, FiMenu, FiX, FiFileText } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/admin', icon: <FiGrid />, label: 'Dashboard', end: true },
  { to: '/admin/projects', icon: <FiFolderPlus />, label: 'Projects' },
  { to: '/admin/team', icon: <FiUsers />, label: 'Team Members' },
  { to: '/admin/testimonials', icon: <FiMessageSquare />, label: 'Testimonials' },
  { to: '/admin/bookings', icon: <FiCalendar />, label: 'Bookings' },
  { to: '/admin/certificates', icon: <FiAward />, label: 'Certificates' },
  { to: '/admin/letterhead', icon: <FiFileText />, label: 'Letterhead' },
  { to: '/admin/settings', icon: <FiSettings />, label: 'Settings' },
];

export default function AdminLayout({ children, title }) {
  const [open, setOpen] = useState(false);
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/admin/login'); };

  const SidebarContent = () => (
    <div style={{
      width: 240, background: '#060F1E', height: '100%',
      display: 'flex', flexDirection: 'column',
      fontFamily: 'Outfit, sans-serif', overflowY: 'auto',
    }}>
      <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid rgba(255,255,255,0.06)', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
          <div style={{ width: 34, height: 34, background: 'linear-gradient(135deg, #C9A84C, #E8C96A)', borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Fraunces, serif', fontWeight: 700, color: '#0B2545', fontSize: '1rem', flexShrink: 0 }}>S</div>
          <div>
            <div style={{ color: 'white', fontWeight: 600, fontSize: '0.85rem', lineHeight: 1.2 }}>Smart Quality</div>
            <div style={{ color: '#C9A84C', fontSize: '0.58rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Admin Panel</div>
          </div>
        </div>
      </div>
      <nav style={{ flex: 1, padding: '0.5rem 0', overflowY: 'auto' }}>
        {navItems.map(item => (
          <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setOpen(false)}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: '0.7rem',
              padding: '0.65rem 1.5rem',
              color: isActive ? '#C9A84C' : 'rgba(255,255,255,0.55)',
              background: isActive ? 'rgba(201,168,76,0.08)' : 'transparent',
              borderLeft: `3px solid ${isActive ? '#C9A84C' : 'transparent'}`,
              fontSize: '0.84rem', fontWeight: isActive ? 600 : 400,
              transition: 'all 0.2s', textDecoration: 'none',
            })}>
            <span style={{ fontSize: '1rem', flexShrink: 0 }}>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid rgba(255,255,255,0.06)', flexShrink: 0 }}>
        <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.72rem', marginBottom: '0.6rem' }}>
          Signed in as<br />
          <span style={{ color: 'rgba(255,255,255,0.75)', fontWeight: 500 }}>{admin?.name}</span>
        </div>
        <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem', cursor: 'pointer', background: 'none', border: 'none', fontFamily: 'Outfit, sans-serif', padding: 0 }}>
          <FiLogOut /> Sign Out
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', fontFamily: 'Outfit, sans-serif' }}>

      {/* Desktop sidebar */}
      <div style={{ flexShrink: 0, display: 'none' }} id="admin-sidebar-desktop">
        <SidebarContent />
      </div>

      {/* Mobile overlay */}
      {open && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1000, display: 'flex' }} onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div style={{ width: 240, flexShrink: 0, height: '100%' }}>
            <SidebarContent />
          </div>
          <div style={{ flex: 1, background: 'rgba(0,0,0,0.55)' }} onClick={() => setOpen(false)} />
        </div>
      )}

      {/* Main area */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>

        {/* Header */}
        <header style={{
          background: 'white', borderBottom: '1px solid #F3F4F6',
          padding: '0 1.25rem', height: 58,
          display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
            <button onClick={() => setOpen(!open)} id="admin-ham"
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#0B2545', fontSize: '1.25rem', padding: '0.25rem', display: 'flex', alignItems: 'center' }}>
              {open ? <FiX /> : <FiMenu />}
            </button>
            <h1 className="admin-header-title" style={{ fontSize: '1rem', color: '#0B2545', fontFamily: 'Fraunces, serif', fontWeight: 600, margin: 0 }}>{title}</h1>
          </div>
        </header>

        {/* Content */}
        <main className="admin-main-content" style={{ flex: 1, overflow: 'auto', padding: '1.5rem', background: '#F8F9FA' }}>
          {children}
        </main>
      </div>

      <style>{`
        @media (min-width: 769px) {
          #admin-sidebar-desktop { display: flex !important; }
          #admin-ham { display: none !important; }
        }
        @media (max-width: 768px) {
          #admin-sidebar-desktop { display: none !important; }
          #admin-ham { display: flex !important; }
          .admin-main-content { padding: 1rem !important; }
        }
      `}</style>
    </div>
  );
}